<template>
  <div class="export-csv-loader" :class="{'closed': !isExportsOpen}">
    <div
      class="export-csv-loader-title"
      @click="isExportsOpen = !isExportsOpen"
    >
      <h2 v-t="'EXPORTED_FILES_DETAILS'" />
      <i
        class="fa fa-chevron-up"
        :class="{ 'fa-rotate-180': !isExportsOpen }"
        aria-hidden="true"
      ></i>
    </div>
    <div class="export-csv-loader-files">
      <div
        v-for="job in exportJobs"
        :key="job.id"
        class="export-job"
      >
        <ExportJobItem :job="job" />
      </div>
    </div>
  </div>
</template>

<script> 

import ExportJobItem from '../ExportJobItem';
import { mapState } from 'vuex';
import messages from './locales';

export default {
  name: 'ExportFileLoader',
  components: {
    ExportJobItem,
  },
  
  data() {
    return {
      isExportsOpen: true
    };
  }, 

  computed: {
    ...mapState('exportFiles', [
      'exportJobs',
    ])
  }, 
  watch: {
    exportJobs: {
      handler() {
        this.isExportsOpen = true;
      },
      immediate: true,
      deep: true
    },
  },
  i18n: {
    messages,
    locale: 'en'
  }
};
</script>

<style lang="scss" scoped>

</style>